export const MODULE_NAMES = {
  CITIES: "cities",
  COUNTRIES: "countries",
  ACCESS_LEVELS: "access-levels",
  TRAFFIC_SOURCES: "traffic-sources",
  RECEIPTS: "receipts",
  LEAD_REPORT: "generated-lead-report",
  USERS: "users",
  GROUPS: "groups",
  TICKETS: "tickets",
  CLIENT_APPS: "client-apps",
  TARIFFS: "tariffs",
  PAYMENT_PROVIDER_MODELS: "payment-provider-models",
  ROLES: "roles",
  LANDINGS: "landings",
  LANDING_DOMAINS: "landing-domains",
  LANDING_REGIONS: "landing-regions",
  APP_VERSION_FLAGS: "app-version-flags",
  MAIL_SUBJECTS: "mail-subjects",
  RADIUS_VPN_SERVERS: "radius-vpn-servers",
  REBILLS: "rebills",
  REBILLS_GROUPS: "rebills-groups",
  CAMPAIGNS: "campaigns",
  CAMPAIGN_TDS: "campaign-tds",
  DEVICE_TYPES: "device-types",
  TRACKERS: "trackers",
  APPLE_MODELS: "apple-models",
  OS: "os",
  STATISTICS: "statistics",
  STATISTICS_GROUPS: "statistics-groups",
  DATA_CENTERS: "data-centers",
  BLACKLIST_DEVICES: "blacklist-devices",
  PREMIUM_ISSUANCE: "premium-issuance",
  RESEND_PROMO: "resend-promo",
  COUNTRY_PRICES: "country-prices",
} as const;
